import src from "IMAGE";
export default { src, width: 82, height: 89, blurWidth: 0, blurHeight: 0};
